// import react from 'react'
import axios from 'axios'
// import { dictionary } from './../tools/config';


// const baseURL = 'http://localhost/satra-calendar/'
const baseURL = 'http://172.16.102.106:81/'
// const baseURL = 'https://e.satra.ir/'

export const AxiosConfigFileUpload = {
    headers: {
        'content-type': 'multipart/form-data'
    }
}

// // console.log('axios: ', localStorage.getItem('token'))
export const AxiosGeneral = axios.create({
    baseURL: baseURL+'satra-calendar-backend/public/api/',
    // withCredentials: true,
    timeout: 120000,
    headers: { 
        'Accept': 'application/json',
        "Content-Type": "application/json",
        // 'Access-Control-Allow-Origin':'*',
        // 'Access-Control-Allow-Credentials': "true",
        // 'Authorization':"Bearer " + localStorage.getItem('token'),
        // 'Authorization':"Bearer " + localStorage.getItem('token'),
    }
});

